import { render } from "./KrabbeLeukocytes.vue?vue&type=template&id=784c01e6&scoped=true"
import script from "./KrabbeLeukocytes.vue?vue&type=script&lang=js"
export * from "./KrabbeLeukocytes.vue?vue&type=script&lang=js"

import "./KrabbeLeukocytes.vue?vue&type=style&index=0&id=784c01e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-784c01e6"]])

export default __exports__